import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'embryo-Grid3',
  templateUrl: './Grid3.component.html',
  styleUrls: ['./Grid3.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class Grid3Component implements OnInit {

   @Input() blogList : any;

   constructor() { }

   ngOnInit() {
   }

}
